<template>
	<c-dialog ref="dialog" width="550" height="400" @resolve="copyHandle">
		<c-form ref="form" vertical unit-width="100%">
			<c-input type="hidden" name="from_user_id" ></c-input>
			<c-form-item label="源用户" required tip="对该用户进行授权，授权后，其现有的权限将被覆盖">
				<c-input name="from_user_info" disabled></c-input>
			</c-form-item>
            <c-form-item label="权限类型" required>
                <c-checkbox-group name="ref_clients" :options="refClientOptions"></c-checkbox-group>
            </c-form-item>
            <c-form-item label="目标用户" required  tip="将“源用户”的权限复制给“目标用户”">
				<c-select name="to_user_list" async :multiple="{limit:50,linefeed:true}" @search="searchUser" >
                    <template #option="{data, selected}">
                        <select-option
                                :name="data.name"
                                :info="[
                                `${data.data.department_name || ''} | ${data.data.position_name || ''}`
                            ]"
                                :selected="selected"
                        ></select-option>
                    </template>
                </c-select>
			</c-form-item>
        </c-form>
	</c-dialog>
</template>

<script>
	import {mapState} from "vuex";

    export default {
		data() {
			return {
			}
		},
        computed: {
            // 获取dictName选项数据
            ...mapState(['refClientOptions']),
        },
		methods: {
			/************打开复制权限弹框**************/
			open(data) {
				this.$refs.form.clear();
				if (data) {
					this.$refs.form.set({
						from_user_id: data.id,
						from_user_info: data.user_realname + ' | ' + data.department_name + ' | ' + data.position_name
					});
				}
				//填充form表单
				this.$refs.dialog.open({
					title: '复制用户权限'
				});
			},

			/************搜索用户*******************************/
			searchUser(keyword, resolve){
				this.request({
					url:'/system/options',
					data: {
						options_code:'SYSUSER',
						keyword:keyword
					},
					success:data => {
						resolve(data);
					}
				})
			},

			/************复制权限提交处理方法*******************************/
			copyHandle (stop, next){
				stop();
				this.$refs.form.submit({
					url: '/sys_user/user_menu_copy',
					dataFormatter: data => {
						return data;
					},
					rule: {
                        ref_clients: '请至少选择一种权限类型',
						from_user_id: '源用户信息不能为空',
						to_user_list: '请至少选择一个目标用户'
					},
					success: (data, res) => {
						next();
						this.$message({
							message: '权限复制成功',  // 提示内容,
							type: 'success'
						});
						this.$emit('resolve');
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
</style>